<template>
    <a :href="href ? href : signupUrl" target="_blank" :class="'ebc-btn-' + size">
        <slot></slot>
    </a>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "ebc-btn",
    props: {
        size: {
            type: String,
            default: "large"
        },
        href: {
            type: String,
            default: ""
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
}
</script>

<style scoped>
.ebc-btn-large {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 48rem;
    padding: 0 24rem;
    gap: 8rem;
    border-radius: 24rem;
    background: var(--Brand-Secondary-Red, #a52933);
    color: var(--Text-Primary_White, #fff);
    text-align: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2;
    min-width: 200rem;
}

.ebc-btn-large:hover {
    background: var(--Functional-Active-Hover, #cc333f);
    color: var(--Text-Primary_White, #fff);
}

.ebc-btn-large:active {
    background: var(--Functional-Active-Pressed, #7b1e26);
    color: var(--Text-Primary_White, #fff);
}

@media (max-width: 996px) {

    .ebc-btn-large {
        height: 96rem;
        border-radius: 48rem;
        font-size: 32rem;
        font-style: normal;
        font-weight: 500;
        padding: 0 48rem;
        width: 100%;
    }

    .ebc-btn-large .iconfont {
        font-size: 40rem;
    }
}
</style>